import {
    EllipsisHorizontalCircleIcon,
    ArrowPathIcon,
    CheckCircleIcon,
    XCircleIcon,
} from '@heroicons/react/24/outline';
import type { Database } from '@/types/database.types';

export type TaskStatus = Database['public']['Tables']['tasks']['Row']['status'];

export interface StatusConfig {
    label: string;
    bgClass: string;
    textClass: string;
    borderClass: string;
    Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

export const STATUS_CONFIG: Record<TaskStatus, StatusConfig> = {
    not_started: {
        label: 'Not Started',
        bgClass: 'bg-gray-100',
        textClass: 'text-gray-700',
        borderClass: 'border-gray-200',
        Icon: EllipsisHorizontalCircleIcon,
    },
    in_progress: {
        label: 'In Progress',
        bgClass: 'bg-blue-100',
        textClass: 'text-blue-700',
        borderClass: 'border-blue-200',
        Icon: ArrowPathIcon,
    },
    completed: {
        label: 'Completed',
        bgClass: 'bg-green-100',
        textClass: 'text-green-700',
        borderClass: 'border-green-200',
        Icon: CheckCircleIcon,
    },
    blocked: {
        label: 'Blocked',
        bgClass: 'bg-red-100',
        textClass: 'text-red-700',
        borderClass: 'border-red-200',
        Icon: XCircleIcon,
    },
};

export const ALL_STATUSES: TaskStatus[] = ['not_started', 'in_progress', 'completed', 'blocked'];

export const CTRL_KEY_STATUS_MAP: Record<string, TaskStatus> = {
    '1': 'not_started',
    '2': 'in_progress',
    '3': 'completed',
    b: 'blocked',
    B: 'blocked',
};
